export const styles = {
  mainContainer: {
    position: "relative",
    width: "calc(100vw - 16px)",
    height: "calc(100vh - 16px)",
    overflow: "hidden",
    margin: 1,
    padding: 0,
    borderRadius: "16px",
    border: "1px solid #183059",
  },
  mapWrapper: {
    width: "100%",
    height: "100%",
    position: "absolute",
    top: 0,
    left: 0,
  },
  loadingContainer: {
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    height: "100%",
    width: "100%",
  },
  headerContainer: {
    position: "absolute",
    top: { xs: "0px", md: "17px" },
    left: { xs: "0", md: "50%" },
    transform: { xs: "none", md: "translateX(-50%)" },
    zIndex: 1000,
    width: { xs: "100%", md: "auto" },
    minWidth: { xs: "unset", md: "360px" },
    maxWidth: { xs: "100%", md: "90%" },
    padding: { xs: "0", md: "0 16px" },
  },
  headerBackground: {
    backgroundColor: "#183059",
    border: "1px solid #A5DCF3",
    borderRadius: "16px 16px 0px 0px",
  },
  headerContent: {
    display: "flex",
    minHeight: "64px",
    alignItems: "stretch",
    width: "100%",
  },
  specialStatusContainer: {
    flex: 1,
    display: "flex",
    flexDirection: "column",
    justifyContent: "center",
    alignItems: "center",
    padding: "12px 24px",
    minHeight: "64px",
  },
  specialStatusText: {
    fontSize: "18px",
    fontWeight: 600,
    color: "#FFFFFF",
    textAlign: "center",
    lineHeight: "1.3",
  },
  nextStopContainer: {
    padding: "12px 16px",
    borderBottom: "2px solid #C8CBD0",
    borderRight: "2px solid #C8CBD0",
    textAlign: "center",
  },
  nextStopLabel: {
    fontSize: "14px",
    color: "#647490",
    fontWeight: 500,
  },
  nextStopName: {
    fontSize: "18px",
    fontWeight: 700,
    color: "#FFFFFF",
    marginTop: "4px",
  },
  distanceContainer: {
    flex: 1,
    display: "flex",
    flexDirection: "column",
    justifyContent: "center",
    alignItems: "center",
    borderRight: "2px solid #C8CBD0",
    padding: "12px 16px",
    gap: "4px",
    minWidth: "0",
  },
  etaContainer: {
    flex: 1,
    display: "flex",
    flexDirection: "column",
    justifyContent: "center",
    alignItems: "center",
    padding: "12px 16px",
    gap: "4px",
    minWidth: "0",
  },
  metricValue: {
    fontSize: "24px",
    fontWeight: 700,
    color: "#FFFFFF",
    lineHeight: "1.2",
    textAlign: "center",
    wordBreak: "break-word",
    maxWidth: "100%",
  },
  metricLabel: {
    fontSize: "14px",
    color: "#C8CBD0",
    marginTop: "2px",
    textAlign: "center",
    whiteSpace: "nowrap",
  },
  sosButtonContainer: {
    position: "absolute",
    bottom: "24px",
    right: "24px",
    zIndex: 1000,
  },
  sosButton: {
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    justifyContent: "center",
    width: "56px",
    height: "56px",
    borderRadius: "50%",
    backgroundColor: "#D72020",
    border: "none",
    cursor: "pointer",
    boxShadow: "0px 4px 12px rgba(215, 32, 32, 0.4)",
    transition: "all 0.3s ease",
    "&:hover": {
      backgroundColor: "#E6352B",
      transform: "scale(1.05)",
      boxShadow: "0px 6px 16px rgba(215, 32, 32, 0.6)",
    },
    "&:active": {
      transform: "scale(0.95)",
    },
  },
  sosText: {
    color: "#FFFFFF",
    fontSize: "16px",
    fontWeight: 700,
    letterSpacing: "1px",
  },
  callLinkDisabled: {
    textDecoration: "none",
    cursor: "not-allowed",
    pointerEvents: "none",
  },
};
